<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "NOV Templates",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "NOV Templates",
      items: [
        {
          text: "Home",
        },
         {
          text: "Settings",
        },
        {
          text: "NOV Templates",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>